<template>
  <div class="outer-hg-100">
    <div class="info-content" :style="{ height: divHeight + 'px' }">
      <div class="make-title">Make Your Test</div>
      <div class="test-name">Test Name</div>
      <div class="myt-input myt-test-input">
        <v-text-field
          v-model="testName"
          label="Test Name"
          dense
          outlined
          hide-details
          ref="userId"
        ></v-text-field>
      </div>
      <div class="test-name">Target Exam</div>
      <div class="card-panel">
        <v-radio-group v-model="selectedTarget" @change="changedTarget" class="jee-user-row">
          <div
            class="card-data"
            @click="selectedTarget = item.value"
            :style="
              selectedTarget === item.value
                ? { border: '1px solid #089BE5' }
                : ''
            "
            v-for="(item, index) in targets"
            :key="index"
          >
            <img
              :src=item.image_url
              class="card-icon"
            />
            <div class="card-title jee-ug" :class="item.text.toLowerCase()">
              {{ item.text }}
            </div>
            <v-radio color="secondary-darken-3" :value="item.value"></v-radio>
          </div>
        </v-radio-group>
      </div>
    </div>
    <div class="footer-btn">
      <div></div>
      <v-btn
        color="primary"
        class="cust-btn myt-next"
        @click="checkTestLimit()"
      >
        Next
      </v-btn>
    </div>
    <AlertBox :width="modalwidth" :onClose="onClose" :component="cComponent" :status="status" :data="alertBoxData" />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import constants from "@/utils/constants.js";

export default {
  props: ["data", "onNextClick", "testCount"],
  name: "StepOneData",
  data() {
    return {
      e1: 1,
      targets: null,
      selectedTarget: null,
      testName: "",
      subjects: null,
      isTargetChanged:false,
      alertBoxData:"",
      modalwidth: "",
      cComponent: "",
      status: false,
      checkTestFlag:true,
      elemHeight:null
    };
  },
  computed:{
    divHeight() {
      this.updateDivHeight();
      return this.elemHeight 
    },
  },
  destroyed(){
    window.removeEventListener("resize", this.updateDivHeight);
  },
  created(){
    window.addEventListener("resize", this.updateDivHeight);
  },
  mounted() {
    if(this.data){
      this.testName = this.data.testName;
      this.selectedTarget = this.data.selectedTarget;
      // this.targets = this.data.targets;
    }
    // else{
      this.reqGetTestTargets();
    // }
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getMYTTestPatterns: "utilStore/getMYTTestPatterns",
      createCustomTestAPI: "testStore/createCustomTest",
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic"
    }),
    reqGetTestTargets() {
      let reqData = {
        myt_pattern: true
      };
      this.getTestTarget(reqData)
        .then((response) => {
          this.loading = false;
          this.targets =
            response &&
            response.length &&
            response.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              c.checked = false;
              c.image_url = x.image_url
              c.subjects = x.subjects;
              c.target_exam_id = x.target_exam_id;
              return c;
            });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    updateDivHeight(){
      if (window.innerWidth > constants.MOBILE_MAX_WIDTH) {
        this.$nextTick(() => {
          this.elemHeight=  this.setDivHeight();
         });    
      }
    },
    changedTarget(){
      this.isTargetChanged=true
    },
    onClose(data){
      this.status=data.status;
      if(data.testLimitPopup){
        this.checkTestFlag=false;
        this.checkTestLimit();
      }
    },
    checkTestLimit(){
      if(this.testCount<=3 && this.checkTestFlag){
        this.cComponent =  "views/pages/mytuser/components/TestLimitPopup";
        this.alertBoxData = {testCount:this.testCount};
        this.alertBoxData.persistent = true;
        this.status = true;
        this.modalwidth = '400px';
      }
      else{
        let testName=this.testName
        let selectedTarget=this.selectedTarget
        let targets=this.targets
        let isTargetChanged=this.isTargetChanged
        this.onNextClick({ testName, selectedTarget, targets,isTargetChanged });
      }
    }
  }
};
</script>
